import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  right: 36px;
  bottom: 16px;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: flex-end;

  > img {
    width: 100%;
    max-width: 170px;
  }
`
